import Component from './InstagramAnalyticsPublicFilter.vue'
export default Component
